<template>
  <SimpleFloorPlanEditor />
</template>

<script>
import SimpleFloorPlanEditor from './components/SimpleFloorPlanEditor.vue'

export default {
  name: 'App',
  components: {
    SimpleFloorPlanEditor
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, html, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
